import { createAction, createReducer } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import { apiCallBegan } from 'store/apiCalls'
import { gameIdSelector } from 'store/user/selectors'
import i18n from 'i18n'

// ACTIONS
const forecastRequested = createAction('marketForecast/requested')
const forecastReceived = createAction('marketForecast/received')
const forecastFailed = createAction('marketForecast/failed')

// REDUCER
export const initialState = {
  data: {},
  loading: false,
  requestForecastSuccess: false
}

const marketForecastReducer = createReducer(initialState, {
  [forecastRequested.type]: (state) => {
    state.loading = true
    state.requestForecastSuccess = false
  },
  [forecastReceived.type]: (state, action) => {
    state.loading = false
    state.requestForecastSuccess = true
    state.data = action.payload.data
  },
  [forecastFailed.type]: (state, action) => {
    state.loading = false
    toast.error(i18n.t(action.payload.message))
  }
})

export default marketForecastReducer

// PUBLIC ACTIONS
export const loadMarketForecast = () => (dispatch, getState) => {
  const id = gameIdSelector(getState())
  dispatch(
    apiCallBegan({
      url: `/games/${id}/market_forecast`,
      onStart: forecastRequested.type,
      onSuccess: forecastReceived.type,
      onError: forecastFailed.type
    })
  )
}
